import posthog from 'posthog-js';
import auth from '../utils/auth';

const trackingServices = {

  getPostHogInstance() {
    const apiHost = 'https://eu.posthog.com';
    auth.getConf().then((response) => {
      posthog.init(response.CONF.TOKEN_POSTHOG, {
        api_host: apiHost,
        autocapture: false,
        capture_pageview: false,
        capture_pageleave: false,
      });
    });
    return posthog;
  },

  login(method, mail) {
    posthog.identify(mail);
    posthog.capture('User Login', {
      auth_provider: method,
    });
  },

  accountActivated(method) {
    posthog.capture('User Account Activated', {
      auth_provider: method,
    });
  },

  passwordResetRequested(mode, mail) {
    posthog.identify(mail);
    posthog.capture('Password Reset Requested', { reset_code_destination: mode });
  },

  passwordResetDone(mail) {
    posthog.identify(mail);
    posthog.capture('Password Reset Done');
  },

  accountActivationError(error) {
    posthog.capture('Account Activation Error', { error });
  },

  resendActivationCodeRequested(email) {
    posthog.capture('Account Activation Code Resent', { email });
  },

  accountActivationStartedSuccessfully(email) {
    posthog.identify(email);
    posthog.capture('Account Activation Started', { email });
  },

  accountActivationEmailVerifiedSuccessfully(email) {
    posthog.identify(email);
    posthog.capture('Activation Email Verified', { email });
  },

  accountActivationEmailVerifiedFailed(error) {
    posthog.capture('Activation Email Verification Failed', { error_code: error.code, error_content: error.content });
  },

  accountActivationStartedFailed(error) {
    posthog.capture('Account Activation Start Failed', { error_type: error });
  },
};

export default trackingServices;



// WEBPACK FOOTER //
// ./src/plugins/posthog.js